import { z } from "zod";

export const getDashboardOverviewInputSchema = z.object({
  organizationId: z.string().min(1),
});

export const dashboardMetricBreakdownSchema = z.object({
  completed: z.number(),
  draft: z.number(),
  awaitingExport: z.number(),
});

export const dashboardTurnaroundSchema = z.object({
  averageDays: z.number().nullable(),
  sampleSize: z.number(),
});

export const dashboardTimeSavedSchema = z.object({
  completedSurveys: z.number(),
  hoursSaved: z.number(),
  workingDaysSaved: z.number(),
});

export const dashboardUrgencyBucketSchema = z.object({
  bucket: z.enum(["MAINT", "ATTN", "URG"]),
  label: z.string(),
  count: z.number(),
});

export const dashboardFindingSchema = z.object({
  finding: z.string(),
  area: z.string().nullable(),
  item: z.string().nullable(),
  count: z.number(),
});

export const dashboardDistributionEntrySchema = z.object({
  label: z.string(),
  count: z.number(),
});

export const dashboardAreaInsightSchema = z.object({
  area: z.string(),
  findingsCount: z.number(),
  recommendationsCount: z.number(),
  totalCount: z.number(),
});

export const dashboardTrendPointSchema = z.object({
  month: z.string(),
  findingsCount: z.number(),
  recommendationsCount: z.number(),
  totalCount: z.number(),
});

export const dashboardOverviewResponseSchema = z.object({
  generatedAt: z.string(),
  surveysThisMonth: dashboardMetricBreakdownSchema,
  averageReportTurnaround: dashboardTurnaroundSchema,
  estimatedTimeSaved: dashboardTimeSavedSchema,
  recommendationUrgency: z.object({
    total: z.number(),
    buckets: z.array(dashboardUrgencyBucketSchema),
  }),
  mostCommonFindings: z.array(dashboardFindingSchema),
  vesselTypeDistribution: z.array(dashboardDistributionEntrySchema),
  issuesByArea: z.array(dashboardAreaInsightSchema),
  findingsTrend: z.array(dashboardTrendPointSchema),
});

export type DashboardOverviewResponse = z.infer<
  typeof dashboardOverviewResponseSchema
>;
